/**
 * Booking rules the marketing site has to respect so it does not promise a
 * dispatch mode the app will refuse.
 *
 * MIRRORS THE APP. The user app holds the authoritative value in
 * `constants/instantTripPolicy.ts` (`INSTANT_MAX_DISTANCE_KM = 120`). The two
 * codebases share no packages, so this is a deliberate copy — if the app's limit
 * changes, change it here too.
 *
 * Why it matters on the web: the public fare endpoint prices any distance
 * without flagging one. East London to Durban (670 km) returns a normal
 * estimate, so the site quoted an instant-looking fare for a trip the app sends
 * to its `schedule-required` screen instead. The estimate itself is still
 * valid — it is the *dispatch mode* that differs, which is what the widget now
 * says.
 */

export const INSTANT_MAX_DISTANCE_KM = 120;

export function requiresScheduledBooking(distanceKm: number | null | undefined): boolean {
  return typeof distanceKm === 'number' && distanceKm > INSTANT_MAX_DISTANCE_KM;
}
